<template>
    <div>
        <ProgressBar :currentStepIndex="1" />

        <div class="contentblock">
            <section class="contentblock__content">
                <div class="pneu-offer__fieldgroup">
                    <div class="pneu-offer__fieldgroup-title">{{strings['PneuOffer.PickServices']}}</div>

                    <strong>{{strings['PneuOffer.SummaryTyreTitle']}}</strong>
                    <SelectedTyre />
                    
                    <div class="pneu-offer__services-rimtype">
                        <SelectWithLabel v-model="rimType"
                                         label="Felgentyp"
                                         rules="required"
                                         :options="rimTypeOptions" v-if="showRimTypePicker" />
                    </div>

                    <table class="pneu-offer__services-list">
                        <tr>
                            <th>{{strings['PneuOffer.Service']}}</th>
                            <th class="pneu-offer__service-price-col">{{strings['PneuOffer.UnitPrice']}}</th>
                        </tr>
                        <tr v-for="service in bookableServices" :key="service.ID">
                            <td>
                                <Checkbox v-model="service.IsBooked">
                                    <strong>{{service.Title}}</strong><br />                                    
                                    <a href="#" @click.prevent="service.DescriptionExpanded = true" v-if="!service.DescriptionExpanded">{{strings['PneuOffer.ServicesExpand']}}</a>
                                    <span v-if="service.DescriptionExpanded">{{service.Description}}</span>
                                </Checkbox>                                
                            </td>
                            <td class="pneu-offer__service-price-col">{{getServicePrice(service) | formatPrice}}</td>
                        </tr>
                    </table>
                </div>
                <div class="pneu-offer__fieldgroup pneu-offer__fieldgroup--buttons">
                    <div class="pneu-offer__nav-buttons">
                        <button @click="back()" class="migrol-form__button">{{strings['Global.Back']}}</button>
                        <button @click="next()" class="migrol-form__button migrol-form__button--green">{{strings['Global.Continue']}}</button>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
    import { mapState, mapMutations } from 'vuex';
    import { CarTypes } from '@/utils/constants';
    import ProgressBar from './_common/ProgressBar';
    import SelectedTyre from './_common/SelectedTyre';
    import * as gaTracking from "@/utils/gaTracking";
    
    export default {
        computed: {
            ...mapState([
                'strings',
                'settings',
                'enums',
                'carType'
            ]),
            showRimTypePicker() {
                return this.carType == CarTypes.PKW;
            },
            rimTypeOptions() {
                return this.enums['RimTypes'].map((val) => { return { text: val.text, id: val.value } });
            },
            rimType: {
                get() { return this.$store.state.rimType; },
                set(type) { this.setRimType(type); }
            },
            bookableServices() {
                return this.settings['Services'].filter(service => service.IsBookable);
            }
        },
        methods: {
            ...mapMutations([
                'setRimType'
            ]),
            changeService(isBooked, service) {
                service.IsBooked = isBooked;
            },
            back() {
                this.$router.push('/step1').catch(() => { });
            },
            next() {
                gaTracking.trackAddToCart(this.$store.state);
                this.$router.push('/step3').catch(() => { });
            }
        },
        mounted() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        },
        components: {
            ProgressBar,
            SelectedTyre
        }
    };
</script>